<template>
    <div class="welcome-quick-settings skin-window--welcome">
        <v-card-text class="welcome-quick-settings-text">
            <v-switch
                :input-value="rightHandedFlag"
                @change="setRightHandedFlag"
                hide-details
                color="secondary"
                :label="$t('journey.welcomeQuickSettings.rightHandedLabel')"
            />
            <v-switch
                :input-value="darkThemeFlag"
                @change="setDarkThemeFlag"
                hide-details
                color="secondary"
                :label="$t('journey.welcomeQuickSettings.darkThemeLabel')"
                class="mt-4"
            />
            <v-switch
                :input-value="soundOn"
                @change="toggleSound"
                hide-details
                color="secondary"
                :label="$t('journey.welcomeQuickSettings.soundLabel')"
                class="mt-4"
            />
            <div class="welcome-quick-settings-hint">
                <v-img src="@/assets/pic/web/options_hint.png" contain max-width="260" class="mx-auto mt-4"/>
                <p class="text-center mt-2 welcome-quick-settings-hint-text">
                    {{ $t('journey.welcomeQuickSettings.hint') }}
                </p>
            </div>
        </v-card-text>
        <v-card-actions class="justify-center welcome-quick-settings-actions">
            <v-btn
                rounded
                large
                color="primary black--text"
                class="btn-shadow"
                @click="$emit('continue')"
            >
                {{ $t('journey.welcomeQuickSettings.continueBtn') }}
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    // První krok před Oak uvítáním (StartingNext.vue, showQuickSettings).
    // Levák/pravák a theme se zapisují stejným způsobem jako Options.vue
    // (přímo přes setFlag - `flags` je samo o sobě reaktivní Vue.observable).
    import {mapActions, mapGetters} from 'vuex';
    import {flags, setFlag} from '@/config/featureFlags';
    import {API_ENTRYPOINT} from '@/config/entrypoint';
    import {setStoredMusicVolume, setStoredButtonVolume} from '@/utils/volumeStorage';

    export default {
        name: 'WelcomeQuickSettings',
        computed: {
            ...mapGetters({
                musicVolume: 'journey/musicVolume',
                buttonVolume: 'journey/buttonVolume',
                user: 'user/item',
            }),
            rightHandedFlag() {
                return flags.rightHanded;
            },
            darkThemeFlag() {
                return flags.darkTheme;
            },
            soundOn() {
                return this.musicVolume > 0 || this.buttonVolume > 0;
            },
        },
        created() {
            // Čerstvý trenér má musicVolume i buttonVolume vždy 0 (DB default) -
            // bez tohodle by přepínač "Zvuk" defaultně ukazoval OFF. Guard na
            // 0/0 zajistí, že se tohle nikdy nepřepíše přes už přizpůsobenou
            // hlasitost.
            if (this.musicVolume === 0 && this.buttonVolume === 0) {
                this.musicVolumeSetup(20);
                this.buttonsVolumeSetup(20);
                this.saveVolumeSettings();
            }
        },
        methods: {
            ...mapActions({
                musicVolumeSetup: 'journey/musicVolumeSetup',
                buttonsVolumeSetup: 'journey/buttonsVolumeSetup',
                fetchTrainer: 'user/fetchObject',
                editUser: 'user/editUser',
            }),
            setRightHandedFlag(v) {
                setFlag('rightHanded', !!v);
            },
            setDarkThemeFlag(v) {
                setFlag('darkTheme', !!v);
            },
            toggleSound(v) {
                const volume = v ? 100 : 0;
                this.musicVolumeSetup(volume);
                this.buttonsVolumeSetup(volume);
                this.saveVolumeSettings();
            },
            // Stejný vzor jako SoundSettings.vue saveVolumeSettings() - uložení
            // hlasitosti přímo na Trainer entitu + lokálně per-zařízení.
            saveVolumeSettings() {
                setStoredMusicVolume(this.user.id, this.musicVolume);
                setStoredButtonVolume(this.user.id, this.buttonVolume);
                const url = new URL('api/trainers/' + this.user.id, API_ENTRYPOINT);
                const obj = {url, obj: {musicVolume: this.musicVolume, buttonVolume: this.buttonVolume}, method: 'PATCH'};
                this.fetchTrainer(obj).then((data) => {
                    this.editUser(data);
                });
            },
        },
    }
</script>

<style scoped>
.welcome-quick-settings-text {
    font-size: 15px;
}
.welcome-quick-settings-hint-text {
    font-size: 13px;
    opacity: 0.8;
}
.welcome-quick-settings-actions {
    padding-bottom: var(--responsive-dialog-close-clearance);
}
</style>
